// extracted by mini-css-extract-plugin
export default {"container":"gdpTable_container__ZYI+m","header":"gdpTable_header__pgJ8W"};